import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'qaroni-allowance-progress-bar-preview',
  templateUrl: './allowance-progress-bar-preview.component.html',
  styleUrls: ['./allowance-progress-bar-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AllowanceProgressBarPreviewComponent {
  readonly value = input<number>(0);
  readonly total = input<number | string>(null);

  get percentage(): number {
    const total = Number(this.total());
    return total ? (Number(this.value()) / total) * 100 : 0;
  }
}
